import { ArticleText } from 'ui/components';

export const ArticleTextFeature: React.FC<Content.ArticleText> = ({ content }) => <ArticleText {...content?.properties} />;
